import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RetailersComponent } from '@app/features/retailers/retailers/retailers.component';
import { AddRetailerComponent } from '@app/features/retailers/add-retailer/add-retailer.component';
import { ViewRetailerComponent } from '@app/features/retailers/view-retailer/view-retailer.component';
import { EditRetailerComponent } from '@app/features/retailers/edit-retailer/edit-retailer.component';
import { ManageRetailerUsersComponent } from '@src/app/features/retailers/manage-retailer-users/manage-retailer-users.component';

const routes: Routes = [
  { path: '', component: RetailersComponent },
  { path: 'add', component: AddRetailerComponent },
  { path: ':retailerId/edit', component: EditRetailerComponent },
  { path: ':retailerId', component: ViewRetailerComponent },
  { path: ':retailerId/manage-users', component: ManageRetailerUsersComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RetailersRoutingModule { }
